module.exports = __webpack_public_path__ + "static/media/import-export-arrows.59b2babf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/import-export-arrows.svg
// module id = ./src/assets/images/import-export-arrows.svg
// module chunks = 6